module.exports = __webpack_public_path__ + "static/media/actionable-insights.b6a78368.svg";